const API_BASE_URL = import.meta.env.VITE_API_URL;

export const trackingService = {
  async getActiveTracking(): Promise<{ key: string; value: string }[]> {
    const response = await fetch(`${API_BASE_URL}/tracking/public.php`);
    const data = await response.json();
    if (!data.success) return [];
    return data.data.map((item: any) => ({ key: item.config_key, value: item.value }));
  }
};
